import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUiLoading } from './@core/store/ui/ui.selector';
import { InitAuth } from './@core/store/auth/auth.actions';
import { selectAuthRedirectSuccess } from './@core/store/auth/auth.selectors';
import { Router } from '@angular/router';
import { InitAuthAdmin } from './@core/store/auth-admin/auth-admin.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnDestroy {
  title = 'veritasms';
  loading$: Observable<boolean>;
  destroySubject$: Subject<void> = new Subject<void>();

  constructor(public store: Store, public router: Router) {
    this.loading$ = this.store.select(selectUiLoading);
    this.adminAuthInit();
    this.store.dispatch(InitAuth());

    this.store
      .select(selectAuthRedirectSuccess)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data: 'admin' | boolean) => {
        if (data === 'admin') {
          this.router.navigate(['/admin']);
        }

        if (data === true) {
          this.router.navigate(['/']);
        }
      });
  }

  adminAuthInit(): void {
    this.store.dispatch(InitAuthAdmin());
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.unsubscribe();
  }
}
